export default __webpack_public_path__ + "static/media/2020_Ke_and_Wan_2020_EcologicalMonographs.823a16a5.pdf";